import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { initMatomo, trackPageView } from '../../utils/matomo';

/**
 * Composant Matomo : initialise le tracker et envoie une page view à chaque changement de route.
 * Ne fait rien si REACT_APP_MATOMO_URL et REACT_APP_MATOMO_SITE_ID ne sont pas définis.
 */
function MatomoTracker() {
  const location = useLocation();

  useEffect(() => {
    initMatomo();
  }, []);

  useEffect(() => {
    trackPageView(location.pathname + location.search);
  }, [location.pathname, location.search]);

  return null;
}

export default MatomoTracker;
